// roles.ts
export const USER_ROLES = ['admin', 'contributor'] as const;
export type UserRole = (typeof USER_ROLES)[number]; // 'admin' | 'contributor'
